module.exports = __webpack_public_path__ + "img/components (18).6bb27560.png";